module.exports = __webpack_public_path__ + "static/media/2 valhalla warrior female coverup viking color tattoo.1222x1685.672258e0.webp";